import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './bootstrap/css/bootstrap.min.css';
import './ol.css';
import './load_spin.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Livingplaces from './models/livingplacecoll';
import Livingplaces_miscdata from './models/miscStates';

var hasInit = false;

Livingplaces_miscdata.add([{id: "1"}])
Livingplaces_miscdata.add([{id: "2"}])

window.datastore = {lps: Livingplaces, lps_misc: Livingplaces_miscdata}


ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js